import { __ } from '@wordpress/i18n';
import { useClipboard } from '@wp-g2/utils';
import React from 'react';
import { ColorCircle } from '../ColorCircle';
import { Tooltip } from '../Tooltip';
import { VStack } from '../VStack';
import { useColorPickerContext } from './ColorPicker.Context';
import * as styles from './ColorPicker.styles';
export var ColorPickerPreview = /*#__PURE__*/React.memo(function () {
  var _useColorPickerContex = useColorPickerContext(),
      color = _useColorPickerContex.colorValue,
      showPreview = _useColorPickerContex.showPreview;

  var _useClipboard = useClipboard(color),
      hasCopied = _useClipboard.hasCopied,
      onCopy = _useClipboard.onCopy;

  if (!showPreview) return null;
  var tooltipContent = hasCopied ? __('Copied') : __('Copy');
  return /*#__PURE__*/React.createElement(VStack, {
    alignment: "center"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: tooltipContent
  }, /*#__PURE__*/React.createElement(ColorCircle, {
    className: styles.ColorPreview,
    color: color,
    onClick: onCopy
  })));
});